// The legacy transaction consumes a line's entire quantity from each source ID.
// Preserve one line per source, even when sources contain the same product.
export const previousDetailLines = (details) =>
  details
    .filter((detail) => Number(detail.saldo ?? 0) > 0)
    .map((detail, index) => ({
      ...detail,
      id: null,
      id_encabezado: null,
      folio: 0,
      partida: index + 1,
      cantidad: Number(detail.saldo),
      cantidad2: Number(detail.saldo),
      saldo: Number(detail.saldo),
      ids_detalles: detail.id ? [detail.id] : [],
      _key: `prev-${detail._id_documento_previo}-${detail.id || index}-${Date.now()}`,
    }));
